import React, { FC, PropsWithChildren, useRef } from 'react';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { Navigation } from '@phoenix/core/frontend/shared/ui/global-navigation/navigation';
import { NavItem } from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation.model';
import { CallToAction } from '@phoenix/team-m/dashboard/frontend/shared/components/call-to-action';
import { SmartAppBanner } from '@phoenix/core/frontend/shared/ui/smartapp-banner/smartapp-banner';
import { useMyStihlNavItems } from '@phoenix/team-m/my-tool-shed/frontend/shared/use-my-stihl-nav-items';
import { useSmartBanner } from '@phoenix/core/frontend/shared/feature/use-smart-banner';

interface LayoutProps {
  navItems: NavItem[];
}

export const Layout: FC<PropsWithChildren<LayoutProps>> = ({ navItems, children }) => {
  const { auth } = useCore();
  const smartBannerRef = useRef<HTMLDivElement>(null);
  const {
    appName,
    appDescription,
    buttonText,
    show: showSmartBanner,
    offsetHeight: smartBannerHeight,
  } = useSmartBanner({ landingPages: ['/[locale]/tool-shed', '/[locale]/tool-shed/add-tool'], ref: smartBannerRef });

  return (
    <>
      <SmartAppBanner
        appName={appName}
        appDescription={appDescription}
        buttonText={buttonText}
        isEnabled={showSmartBanner}
        ref={smartBannerRef}
      />
      <CallToAction allowReferrer={true} />
      <Navigation
        auth={{
          displayName: `${auth?.user?.given_name} ${auth?.user?.family_name}`,
          isAuthenticated: !!auth?.isAuthenticated,
          onLogout: auth?.onLogout,
        }}
        mainNavItems={useMyStihlNavItems(navItems)}
        homeLinkId="my-stihl-home"
        topOffset={smartBannerHeight}
      />
      <main>{children}</main>
    </>
  );
};
